export default __webpack_public_path__ + "static/media/Artwork.a76d0c11.svg";